



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChildrenAvatarStub, Indicator } from './components';
import IAvatar from './types';

@Component({
  components: {
    ChildrenAvatarStub,
    Indicator,
  },
})
export default class Avatar extends Vue implements IAvatar {
  @Prop({ type: String, default: '' })
  readonly photo!: string;

  @Prop({ type: String, default: 'M' })
  readonly gender!: string;

  @Prop({ type: Boolean, default: false })
  readonly isIndicator!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isApproved!: boolean;

  @Prop({ type: String, default: '' })
  readonly tooltipText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/Avatar.vue